// BUNDLED: global-bundle.js
export default function() {
	const DISABLE_CLICK_DISTANCE = 5;
	$.fn.dragToScroll = function(dragStartFn, dragEndFn) {
		let clicked = false,
		disableClick = false,
		shouldCallDragStart = true;
		let clickX, clickY, clickXAbs, clickYAbs, totalDistance;
		return this.each(function(index, el) {
			$(el).css('cursor','grab');
			$(el).on({
				'mousemove': function(e) {
					if (clicked) {
						updateScrollPos(e, el);
						if (!disableClick) {
							totalDistance = Math.abs(clickXAbs - e.pageX) + Math.abs(clickYAbs - e.pageY);
							disableClick = totalDistance >= DISABLE_CLICK_DISTANCE;
						}
						if (shouldCallDragStart) {
							dragStartFn && dragStartFn();
							shouldCallDragStart = false;
						}
					}
				},
				'mousedown': function(e) {
					clicked = true;
					clickXAbs = e.pageX;
					clickYAbs = e.pageY;
					clickX = e.pageX - el.offsetLeft + el.scrollLeft;
					clickY = e.pageY - el.offsetTop + el.scrollTop;
					$(el).css('cursor','grabbing');
				},
				'mouseup': function(e) {
					if (clicked) {
						dragEndFn && dragEndFn();
						shouldCallDragStart = true;
					}
					clicked = false;
					$(el).css('cursor','grab');
				},
				'mouseleave': function() {
					if (clicked) {
						dragEndFn && dragEndFn();
						shouldCallDragStart = true;
					}
					clicked = false;
					$(el).css('cursor','grab');
				}
			});
			var updateScrollPos = function(e, el) {
				let currentX = e.pageX - el.offsetLeft;
				let currentY = e.pageY - el.offsetTop;
				$(el).scrollLeft((clickX - currentX));
				$(el).scrollTop((clickY - currentY));
			}
			el.addEventListener('click', (e) => {
				if (disableClick) {
					e.stopPropagation();
					e.stopImmediatePropagation();
					e.preventDefault();
					disableClick = false;
				}
			}, true);
		});
	};

	$.fn.scQtySelector = function(callback) {
		return this.each(function(index, el) {
			let qtyInput = $(el).children('.sc-qty-selector__input');
			let buttons = $(el).children('button');
			buttons.off('click');
			buttons.click((ev) => {
				let adjustment = Number(ev.currentTarget.dataset.adjustment);
				qtyInput.val(Number(qtyInput.val()) + adjustment);
				qtyInput.trigger('change');
			});
			qtyInput.off('change.qty');
			qtyInput.on('change.qty', (ev) => {
				if (Number(ev.target.value) < Number(ev.target.min)) {
					ev.target.value = Number(ev.target.min);
				} else if (Number(ev.target.value) > Number(ev.target.max)) {
					ev.target.value = Number(ev.target.max);
				}
				callback(ev);
			});
		});
	}

	$.fn.scrollInterval = function(handler, interval = 5) {
		let ready = true;
		let timer;
		return this.each(function(index, el) {
			$(el).scroll(function(e) {
				if (!ready && window.scrollY > 0) return; 
				handler.call(this, e);
				ready = false;
				timer && clearTimeout(timer);
				timer = setTimeout(() => {ready = true;}, interval);
			});
		});
	}

	// listens for horizontal swipe gestures on touch screens
	$.fn.onSwipe = function() {

		const config = {
			velocityThreshold: 800,  // velocity in pixels/second above which a swipe is considered "fast" (triggering navigation)
			minimumDistance: 75,     // minimum distance in pixels required to qualify as a swipe gesture (prevents small/accidental touches and allows those to interact with 3d experience)
			timeThreshold: 325,      // maximum duration in milliseconds for a "fast" swipe (longer swipes are considered deliberate/slow)
			horizontalRatio: 0.75     // ratio of horizontal to total movement required to qualify as a horizontal swipe / intentional swipe left or right to trigger navigation
		};

		let touchStartX = 0;
		let touchStartY = 0;
		let touchStartTime = 0;
		let isTracking = false;

		return this.each(function(i,swiperContainer) {
			if (swiperContainer) {
				// capture touch start position and time
				swiperContainer.addEventListener('touchstart', handleTouchStart, { capture: true, passive: true });
				// calculate velocity and trigger navigation
				swiperContainer.addEventListener('touchend', handleTouchEndEvent, { capture: true, passive: true });
				// reset tracking on touch cancel
				swiperContainer.addEventListener('touchcancel', handleTouchCancel, { capture: true, passive: true });
			}
		});

		//calculate swipe velocity and handle navigation
		function handleTouchEnd(endX, endY, endTime, el) {
			if (!isTracking) return;

			// determine if this gesture qualifies as a fast horizontal swipe for navigation
			const deltaX = endX - touchStartX;
			const deltaY = endY - touchStartY;
			const deltaTime = endTime - touchStartTime;
			const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
			const horizontalDistance = Math.abs(deltaX);
			const verticalDistance = Math.abs(deltaY);

			if (distance < config.minimumDistance) return;
			if (deltaTime <= 0) return;

			const velocity = (distance / deltaTime) * 1000;

			const isHorizontalDominant = horizontalDistance / (horizontalDistance + verticalDistance) >= config.horizontalRatio;

			const isFastSwipe = velocity > config.velocityThreshold &&
								deltaTime < config.timeThreshold &&
								isHorizontalDominant;

			if (isFastSwipe) {
				// fast swipe - trigger navigation
				if (deltaX > 0) {
					$(el).trigger('swiperight');
				} else {
					$(el).trigger('swipeleft');
				}
			}
		}

		function handleTouchStart(event) {
			const touch = event.touches ? event.touches[0] : event;
			touchStartX = touch.clientX;
			touchStartY = touch.clientY;
			touchStartTime = Date.now();
			isTracking = true;
		}

		function handleTouchEndEvent(event) {
			// handle touch completion: get data and determine action
			if (!isTracking) {
				isTracking = false;
				return;
			}

			const touch = event.changedTouches ? event.changedTouches[0] : event;
			const endX = touch.clientX;
			const endY = touch.clientY;
			const endTime = Date.now();

			handleTouchEnd(endX, endY, endTime, event.currentTarget);

			isTracking = false;
		}

		// ensure proper state - reset tracking for future events when browser/system takes over the gesture like pinch to zoom
		function handleTouchCancel() {
			isTracking = false;
		}
	}
}
